import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Navbar.jsx'
import Footer from './Footer.jsx'
import { SiteStructuredData } from './StructuredData.jsx'

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Company identity for search engines, emitted once for every page. */}
      <SiteStructuredData />
      <Navbar />
      {/* Floating navbar is fixed-positioned; pt-24 leaves room beneath it.
          This wrapper is intentionally NOT a <main> — each routed page owns
          its own single <main> landmark, so this stays a presentational div. */}
      <div role="presentation" className="flex-1">
        <Suspense
          fallback={
            <div className="grid min-h-[60vh] place-items-center">
              <div className="size-8 animate-spin rounded-full border-2 border-white/15 border-t-[#38bdf8]" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <Footer />
    </div>
  )
}
